import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    email,
    minLength,
    maxLength,
    numeric
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
    name: "AdminUpdate",
    components: {
        MainLayout
    },

    data() {
        return {
            id: this.$store.state.admin.admin['id'],
            adminForm: {
                name: "",
                email: "",
                phone_number: ""
            },
            error_email: "",
            submitted: false
        }
    },

    validations: {
        adminForm: {
            name: {
                required
            },
            email: {
                required,
                email
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            }
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.updateAdmin();
        },

        showAdminUpdate() {
            axios.get("/admin/update/" + this.$route.params.id)
                .then(response => {
                    this.adminForm = response.data;
                })
                .catch(error => {
                    console.log("Admin Update API Error", error);
                });
        },

        updateAdmin() {
            var request = {
                id: this.adminForm.id,
                name: this.adminForm.name,
                email: this.adminForm.email,
                phone_number: this.adminForm.phone_number,
                address: this.adminForm.address,
                gender: this.adminForm.gender
            };
            axios.post("/admin/updated", request)
            .then(response=> {
                if (response.data.msg) {
                    this.error_email = response.data.msg;
                    this.$notification.error("Admin Edit Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else {
                    this.$notification.success("Admin Edited Successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$router.push({
                        name: "adminIndex"
                    });
                }
            });
        }
    },

    mounted() {
        this.showAdminUpdate();
    }
};